import firebase from '../util/firebase';

const GOOGLE_SCOPES = 'https://www.googleapis.com/auth/contacts.readonly';
// const FACEBOOK_SCOPES = 'email,user_likes,user_birthday';
const FACEBOOK_SCOPES = 'email, public_profile';

const resetSign = () => ({ type: 'RESET_SIGN_IN' });
const signInRequest = (isLoading) => ({ type: 'SIGN_IN_REQUEST', isLoading });
const signInSuccess = (user) => ({ type: 'SIGN_IN_SUCCESS', user });
const signInError   = (error) => ({ type: 'SIGN_IN_ERROR', error });

const signOutRequest = (isLoading) => ({ type: 'SIGN_OUT_REQUEST', isLoading });
const signOutSuccess = () => ({ type: 'SIGN_OUT_SUCCESS', user: {} });
const signOutError   = (error) => ({ type: 'SIGN_OUT_ERROR', error });

const signUpRequest = (isLoading) => ({ type: 'SIGN_UP_REQUEST', isLoading });
const signUpSuccess = (user) => ({ type: 'SIGN_UP_SUCCESS', user });
const signUpError   = (error) => ({ type: 'SIGN_UP_ERROR', error });

const sendMailVerificationRequest = (isLoading) => ({ type: 'SEND_MAIL_VERIFICATION_REQUEST', isLoading });
const sendMailVerificationSuccess = () => ({ type: 'SEND_MAIL_VERIFICATION_SUCCESS' });
const sendMailVerificationError   = (error) => ({ type: 'SEND_MAIL_VERIFICATION_ERROR', error });

const resetPasswordSuccess = () => ({ type: 'RESET_PASSWORD_SUCCESS' });
const resetPasswordError   = (error) => ({ type: 'RESET_PASSWORD_ERROR', error });
const resetPasswordClear   = () => ({ type: 'RESET_PASSWORD_CLEAR' });

const loadUserFromSession = () => (dispatch, getState) => {
  dispatch(signInRequest(true));
  return new Promise((resolve, reject) => {
    const unsubscriber =  firebase.auth().onAuthStateChanged(user => {
      if (user) {
        dispatch(signInSuccess(user)); 
        dispatch(signInRequest(false));
        unsubscriber();
        return resolve(user || {}); 
      } else {
        dispatch(signInRequest(false));
        unsubscriber();
        return resolve(user || {});
      }
    });
  });
};

const updateProfile = data => dispatch => {
  dispatch(resetSign());
  dispatch(signInRequest(true));
  const user = firebase.auth().currentUser;

  firebase.database().ref(`usuarios/${user.uid}`).update(data, (err, res) => {
    dispatch(signInRequest(false));
    dispatch(loadUserFromSession());
  });
}

const googleSignIn = () => (dispatch) => {
  dispatch(resetSign());
  let provider = new firebase.auth.GoogleAuthProvider();
  provider.addScope(GOOGLE_SCOPES);
  return signIn(provider, dispatch);
};

const facebookSignIn = () => (dispatch) => {
  dispatch(resetSign());
  let provider = new firebase.auth.FacebookAuthProvider();
  provider.addScope(FACEBOOK_SCOPES);
  return signIn(provider, dispatch);
};

const mailSignIn = (mail, password) => (dispatch) => {
  dispatch(resetSign());
  dispatch(signInRequest(true));
  var user = firebase.auth().currentUser;
  var promise = user ? Promise.resolve(user) : firebase.auth().signInWithEmailAndPassword(mail, password);
  //alert("user: " + user);
  return dispatchSignIn(promise, dispatch);
};

const mailSignUp = (mail, password, nome, telefone) => (dispatch) => {
  dispatch(resetSign());
  dispatch(signUpRequest(true));
  return firebase.auth()
    .createUserWithEmailAndPassword(mail, password)
    .then(() => {
      const key = firebase.auth().currentUser.uid;
      const currentUser = { email: mail, nome, telefone, key };
      firebase.database().ref(`usuarios/${key}`).set(currentUser);
      dispatch(signUpSuccess(currentUser));
      dispatch(sendMailVerification());
    })
    .catch(error => dispatch(signUpError(error.code)))
    .then(() => dispatch(signUpRequest(false)));
};

const sendMailVerification = () => (dispatch) => {
  dispatch(sendMailVerificationRequest(true));
  return firebase.auth().currentUser.sendEmailVerification()
    .then(response => dispatch(sendMailVerificationSuccess()))
    .catch(error => dispatch(sendMailVerificationError(error)))
    .then(() => dispatch(sendMailVerificationRequest(false)));
};

const resetPassword = (email) => (dispatch) => {
  return firebase.auth().sendPasswordResetEmail(email)
    .then(() => dispatch(resetPasswordSuccess()))
    .catch(error => dispatch(resetPasswordError(`reset/${error.code}`)));
};

const clearResetSuccess = () => dispatch => {
  dispatch(resetPasswordClear());
}

const signOut = () => (dispatch) => {
  dispatch(signOutRequest(true));
  return firebase.auth().signOut()
    .then(() => dispatch(signOutSuccess()))
    .catch(error => dispatch(signOutError(error.code)))
    .then(() => dispatch(signOutRequest(false)));
};

const signIn = (provider, dispatch) => {
  dispatch(signInRequest(true));
  var user = firebase.auth().currentUser;
  var promise = user ? Promise.resolve({ user }) : firebase.auth().signInWithPopup(provider);

  return dispatchSignIn(promise, dispatch);
};

const dispatchSignIn = (promise, dispatch) => {
  alert(1);
  let providerData;
  return promise
    .then(response => {
      console.log("response: " + JSON.stringify(response));
      // //providerData = response.hasOwnProperty('uid') && response;
      //console.log("response.getProperty('uid'): " + response.getProperty('uid'));
      console.log("response.uid: " + response.user.uid);
      // return firebase.database().ref(`usuarios/${response.uid}`).once('value');
      console.log("AQUI");
      return firebase.database().ref(`usuarios/${response.user.uid}`).once('value');
    })
    .then(snapshot => {
      console.log("snapshot: " + JSON.stringify(snapshot));
      let user;
      if (snapshot.val()) {
        user = snapshot.val();
      } else {
        user = {
          nome: providerData.displayName,
          email: providerData.email,
          key: providerData.uid,
          avatar: providerData.photoURL,
          role: providerData.role,
        };

        firebase.database().ref(`usuarios/${user.key}`).set(user);
      }

      console.log("user: " + JSON.stringify(user));
      //user.role = "cop-admin";
      //if(user.hasOwnProperty("role")){
        //if(user.role === "cop-admin" || user.role === "god"){
          return Promise.resolve(user);
        //}else{
        //  throw {
        //    code: "auth/user-not-found"
        //  }
        //}
      // }else{
      //   throw {
      //     code: "auth/user-not-found"
      //   }
      // }
    })
    .then(user => dispatch(signInSuccess(user)) )
    .catch(error => dispatch(signInError(error.code)) )
    .then(() => dispatch(signInRequest(false)));
};

const clearLoginError = () => dispatch => {
  dispatch(resetSign());
  dispatch(signOutRequest(true));
  return firebase.auth().signOut()
    .then(() => dispatch(signOutSuccess()))
    .catch(error => dispatch(signOutError(error.code)))
    .then(() => dispatch(signOutRequest(false)));
}

export {
  clearLoginError,
  clearResetSuccess,
  facebookSignIn,
  googleSignIn,
  loadUserFromSession,
  updateProfile,
  mailSignIn,
  mailSignUp,
  resetPassword,
  signOut
};



// WEBPACK FOOTER //
// ./src/actions/auth.js